export const GlobalConst = {
  AdminRole: "Admin",
};
